import "bootstrap-icons/font/bootstrap-icons.css";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import App from "./App";
import "./assets/scss/style.scss";
import Loader from "./layouts/loader/Loader";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import AllocateMe from "./views/AllocateMe";
ReactDOM.render(
  <Suspense fallback={<Loader />}>
    <HashRouter>
      <Provider store={store}>
        {/* <App /> */}

        <AllocateMe />
      </Provider>
    </HashRouter>
  </Suspense>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
